export const getHubList = async (apiCall, scopeId, deviceId, hubType) => {
  let url = `/hub/list?scope=${scopeId}&device=${deviceId}&Type=${hubType}`;

  return await apiCall(url, "GET");
};

export const electHub = async (apiCall, scopeId, deviceId, hubType) => {
  const request = {
    scopeId,
    deviceId,
    hubType,
  };

  try {
    const resp = await apiCall("/hub/elect", "POST", request);
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const rejectHub = async (apiCall, scopeId, deviceId, hubType, hubId) => {
  const request = {
    scopeId,
    deviceId,
    hubType,
    hubId,
  };

  try {
    const resp = await apiCall("/hub/reject", "POST", request);
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const restartHub = async (apiCall, scopeId, deviceId, hubId) => {
  const request = {
    scopeId,
    deviceId,
    hubId,
  };
  try {
    const resp = await apiCall("/hub/restart", "POST", request);
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const saveHub = async (apiCall, scopeId, deviceId, hubType) => {
  try {
    const resp = await apiCall(`/hub/save`, "POST", {
      scopeId,
      deviceId,
      hubType,
    });
    if (resp.error) {
      return null;
    }
    return resp;
  } catch (error) {
    return null;
  }
};

export const getHubStatus = async (apiCall, scopeId) => {
  try {
    const resp = await apiCall(`/hub/status?scope=${scopeId}`, "GET");
    return resp;
  } catch (error) {
    return { error: "UNKNOWN" };
  }
};
